import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import type { Resource, Action } from '../../types/permissions';

interface PermissionRouteProps {
  resource: Resource;
  action: Action;
  redirectTo?: string;
  children: React.ReactElement;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({
  resource,
  action,
  redirectTo = '/dashboard',
  children,
}) => {
  const { can } = usePermissions();
  if (!can(resource, action)) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
};

export default PermissionRoute;
